import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ApiUsuarioService } from '../services/api-usuario.service';
import { AppService } from '../services/app.service';

@Injectable({
    providedIn: 'root'
})
export class UserAdminGuard {

    private readonly _apiUsuario = inject(ApiUsuarioService);
    private readonly _appService = inject(AppService);
    private readonly _router = inject(Router);

    canActivate(): boolean | UrlTree {
        if (this._apiUsuario.isUserAdmin()) {
            return true;
        }
        const rotaRedirecionamento = this._appService.isEmbeddedMode() ? '/pagina-indisponivel' : '/cotacoes';
        return this._router.createUrlTree([rotaRedirecionamento]);
    }
}
